import { apiFetch } from "@core/http";
import type { Benefit, BenefitInput } from "@core/types";

export type { BenefitInput } from "@core/types";

const base = "/v1/portal/benefits";

export interface BenefitFilter {
  active?: boolean;
  categoryId?: string;
}

export const listBenefits = (filter: BenefitFilter = {}) => {
  const params = new URLSearchParams();
  if (filter.active !== undefined) params.set("active", String(filter.active));
  if (filter.categoryId) params.set("categoryId", filter.categoryId);
  const suffix = params.size ? `?${params}` : "";
  return apiFetch<Benefit[]>(`${base}${suffix}`);
};

// El dominio genera `code` (SPEC-211 §3, criterio 1; resolución humana
// PA-025-C): el formulario nunca lo envía, ni al crear ni al editar
// (`BenefitInput` no lo declara), mismo criterio que `RewardInput`
// (rewards/api.ts).
export const createBenefit = (input: BenefitInput) =>
  apiFetch<Benefit>(base, { method: "POST", body: input });

export const editBenefit = (id: string, input: BenefitInput) =>
  apiFetch<Benefit>(`${base}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });

// SPEC-211 §9, resolución humana PA-025-B: DELETE inactiva — nunca un
// borrado permanente. No existe un endpoint `/activate` propio para
// beneficios: reactivar es este mismo `editBenefit` con `active: true`.
export const inactivateBenefit = (id: string) =>
  apiFetch<void>(`${base}/${encodeURIComponent(id)}`, { method: "DELETE" });
